import { z } from "zod";

export const ibicEditorSchema = z.object({
    project_id: z.string(),
    draft_id: z.string(),
    instance_id: z.string(),
    node_id: z.string(),
    expected_revision: z.number().int().positive(),
    options: z.array(z.object({ code: z.string(), label: z.string() }))
});
export type IbicEditorConfig = z.infer<typeof ibicEditorSchema>;
export const ibicPreviewSchema = z.object({ code: z.string(), explanation: z.string().min(1), content: z.string().min(1) });
export type IbicPreview = z.infer<typeof ibicPreviewSchema>;

export function selectedIbicCode(content: string, options: IbicEditorConfig["options"]): string {
    const match = /IBIC\s+kod\s*:\s*([dbe]\d{3,4}[A-Z]?)\b/i.exec(content);
    return options.find(option => option.code.toLowerCase() === match?.[1].toLowerCase())?.code ?? "";
}
